<template>
    <div class="topolo-box">
        <div class="titles">
            <span> {{ detil.title }} </span>
        </div>
        <div class="bg-petri">
            <img src="@/assets/image/petrifaction/bg-2.png" class="am" />
            <div class="dooc" v-html="detil.details"></div>
        </div>
    </div>
</template>

<script>
import { getAction } from "@/api/manage.js";
export default {
    created() {
        this.loadata();
    },
    data() {
        return {
            detil: {},
        };
    },
    methods: {
        loadata() {
            getAction("/act/preface/queryById", {
                id: "1356796102321389562",
            }).then((res) => {
                if (res.success) {
                    this.detil = res.result;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.topolo-box {
    .titles {
        width: 56%;
        border-bottom: 4px double #dca74e;
        margin: 87px auto 20px;
        padding: 5px 0px;
        text-align: center;
        -webkit-animation: scale-in-hor-center 0.6s
            cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
        animation: scale-in-hor-center 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)
            both;
        .icon {
            width: 13%;
            margin-top: 8px;
            margin-left: 27px;
        }
        span {
            font-size: 20px;
            font-weight: bold;
            letter-spacing: 1px;
            color: #333333;
            position: relative;
            top: -14%;
            left: 1%;
        }
    }
    .bg-petri {
        .am {
            position: fixed;
            width: 100%;
            bottom: 0;
            left: 0;
            opacity: .6;
        }
        .dooc{
            padding: 0;
            img{
                width: 100% !important;
                height: auto !important;
            }
        }
    }
}
</style>
